export const translationNavigation_sv_part1 = {
  conversations: "Konversationer",
  uploadData: "Ladda upp data",
  behaviourStudio: "Beteende",
  missingInfoTickets: "Saknad info",
  statistics: "Statistik",
  logout: "Logga ut",
  profileSettings: "Profilinställningar",
  profileSettingsDescription: "Hantera ditt språk, e-postnotifieringar och utseende.",
  languageLabel: "Språk",
  languageSystem: "System",
  languageEnglish: "Engelska",
  languageDanish: "Danska",
  languageSwedish: "Svenska",
  allChatbots: "Alla chatbotar",
  Chatbot: "Chatbot",
  widgetUi: "Widget UI",
  users: "Användare",
  solutions: "Lösningar",
  developer: "Utvecklare",
  connectAi: "MCP Connect",
  visitorBlocks: "Blockerade besökare",
  integrations: "Integrationer",
  organizations: "Organisationer",
  livechat: "Livechat",
  mentionNotificationsNavBadge: "Olästa omnämnanden av dig",
  mentionToastTitle: "Du har blivit omnämnd",
  mentionToastBody: "Någon har omnämnt dig i en konversation.",
  mentionToastOpen: "Öppna konversation",
  notificationClose: "Stäng notifiering",
  livechatNotificationToast: "Ny livechat-aktivitet",
  livechatNotificationToastOpen: "Öppna livechat",
  livechatNotificationOsTitle: "Livechat",
  livechatNotificationOsBody: "Ny livechat-aktivitet väntar på dig.",
  customerOverview: "Ekonomisk översikt",
  productAnalytics: "Produktanalys",
  testPortals: "Testportaler",

  // Financial overview (/revenue)

  // Financial overview (/revenue)
  financialOverviewDescriptionBefore:
    "MRR beräknas som löpande summa av alla betalningshändelser per organisation (",
  financialOverviewDescriptionAfter:
    "). Diagrammet visar månadsvis delta och ackumulerad MRR under de senaste 12 månaderna.",
  financialOverviewRefresh: "Uppdatera",
  financialOverviewFetchError: "Kunde inte hämta data",
  financialOverviewChartTotalMrrLegend: "Total MRR (löpande summa)",
  financialOverviewChartDeltaLegend: "Förändring i månaden (delta)",
  financialOverviewChartGoalLegend: "MRR-mål",
  financialOverviewChartTab: "Översikt",
  financialOverviewGoalsTab: "Målinställningar",
  financialOverviewGoalsDescription:
    "Ange ett MRR-mål för varje månad. Sparade mål visas som en streckad linje i diagrammet.",
  financialOverviewGoalsSave: "Spara mål",
  financialOverviewChartYTitleMrr: "MRR (DKK)",
  financialOverviewChartYTitleDelta: "Delta (DKK)",
  financialOverviewKpiTotalMrr: "Total MRR",
  financialOverviewKpiPayingOrgs: "Betalande organisationer",
  financialOverviewKpiAvgMrrPaying: "Genomsn. MRR (betalande)",
  financialOverviewKpiLatestMonth: "Senaste månaden",
  financialOverviewKpiDeltaSublabel: "Delta i kalendermånad",
  financialOverviewMrrOverTime: "MRR över tid",
  financialOverviewNoMonthlySeries: "Inga månadsserier ännu.",
  financialOverviewOrganizations: "Organisationer",
  financialOverviewRowCount: "{count} rader",
  financialOverviewColOrganization: "Organisation",
  financialOverviewColCurrentMrr: "Aktuell MRR",
  financialOverviewColConversationsLast30Days: "Konversationer (30 dagar)",
  financialOverviewColPricePerConversation: "Pris/konversation",
  financialOverviewColDetails: "Detaljer",
  financialOverviewCtaBusiness: "Företag",
  financialOverviewNoOrgsFound: "Inga organisationer hittades.",
  financialOverviewNoMatchingOrgs: "Inga organisationer matchar din sökning eller dina filter.",
  financialOverviewSearchPlaceholder: "Sök organisationer…",
  financialOverviewSearchAriaLabel: "Sök organisationer efter namn eller Keycloak-id",
  financialOverviewFilterPayingOnly: "Endast betalande",
  financialOverviewRowCountFiltered: "{filtered} av {total} rader",
  financialOverviewMissingKeycloakTitle: "Keycloak-organisations-id saknas",
  financialOverviewTooltipPaymentEvents: "Betalningshändelser",
  financialOverviewTooltipNoEvents: "Inga betalningshändelser denna månad",
  financialOverviewEventTypeIncrease: "Ökning",
  financialOverviewEventTypeDecrease: "Minskning",
  financialOverviewEventTypeChurn: "Churn",

  // Scope picker (sidebar — org / brand / chatbot)

  // Scope picker (sidebar — org / brand / chatbot)
  scopePickerAllChatbots: "Alla chatbotar",
  scopePickerAllCustomers: "Alla kunder",
  scopePickerSearchPlaceholder: "Sök (tryck / för att fokusera)",
  scopePickerRecent: "Senaste",
  scopePickerNoChatbots: "Inga chatbotar tillgängliga",
  scopePickerChatbotCountOne: "1 chatbot",
  scopePickerChatbotCountMany: "{n} chatbotar",
  scopePickerExpand: "Expandera",
  scopePickerCollapse: "Fäll ihop",
  scopePickerOrgUnavailable: "(organisation ej tillgänglig)",
  scopePickerBrandUnavailable: "(varumärke ej tillgängligt)",

  // Test chatbot widget (floating picker in the dashboard)

  // Test chatbot widget (floating picker in the dashboard)
  testChatbotTesting: "Testar",
  testChatbotChoose: "Välj en chatbot",
  testChatbotAuto: "Auto (följer valt scope)",
  testChatbotSearchPlaceholder: "Sök chatbot...",
  testChatbotNoResults: "Inga chatbotar matchar",
  testChatbotHide: "Dölj widget",
  testChatbotShow: "Visa test-chatbot",

  agentNamePlaceholder: "Ange ditt agentnamn",
  livechatConversations: "Konversationer",
  livechatSettings: "Inställningar",
  goToLivechat: "Gå till livechat",
  livechatAvailable: "Den här konversationen är tillgänglig i livechat-läge...",

  // Chatbot configuration translations

  // Chatbot configuration translations
  themeColor: "Primärfärg",
  darkMode: "Mörkt läge",
  enableDarkMode: "Aktivera mörkt läge",
  lightModeTab: "Ljust",
  darkModeTab: "Mörkt",
  darkModePreviewHint:
    "Förhandsvisningen visar ljust läge. Mörkt läge levereras via chatbot-API:et.",
  backgroundColor: "Chattbakgrund",
  backgroundGradientColor: "Bakgrundsgradient",
  headerButtonBackgroundColor: "Sidhuvud-knapp bakgrund",
  headerButtonIconColor: "Sidhuvud-knapp ikon",
  secondaryTextColor: "Dämpad text",
  aiMessageColor: "Assistent-meddelande",
  aiMessageTextColor: "Assistent-meddelande text",
  aiMessageBorderColor: "Assistent-meddelande kant",
  aiMessageThinkingBorderGradient: "Assistent tänkande kant",
  addGradientStop: "Lägg till gradientsteg",
};
